import { CloseIcon } from '@assets/icons/CloseIcon';
import { Antd6Provider } from '@components/shared/Antd6Provider';
import { Tooltip } from 'antd-v6';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

type AIInsightTooltipProps = React.HTMLAttributes<HTMLDivElement> &
  React.PropsWithChildren<{ open?: boolean; onClose: () => void }>;

export const AIInsightTooltip = forwardRef<HTMLDivElement, AIInsightTooltipProps>(
  ({ children, open = false, onClose, ...props }, ref) => {
    const { t } = useTranslation();

    const TooltipContent = (
      <div className="flex items-start gap-1">
        <p className="text-sm">{t('ai_insights.drawer.season_tooltip')}</p>
        <button
          type="button"
          onClick={(ev) => {
            ev.stopPropagation();
            onClose();
          }}
          className="mt-1"
        >
          <CloseIcon width={14} height={14} fill="white" />
        </button>
      </div>
    );

    return (
      <Antd6Provider>
        <Tooltip color="var(--blue-60)" title={TooltipContent} open={open} placement="bottom">
          <div
            ref={ref}
            className={open ? 'outline outline-sy-blue-60 rounded' : undefined}
            {...props}
          >
            {children}
          </div>
        </Tooltip>
      </Antd6Provider>
    );
  }
);

AIInsightTooltip.displayName = 'AIInsightTooltip';
